import { deepFreeze } from '../../utils/misc_utils';

export const FormRouteEnum = deepFreeze({
    NEW: 'NEW',
    EDIT: 'EDIT',
    VIEW: 'VIEW'
});
